// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var spacer = "StickyHeader-module--spacer--OOLXh";
export var wrapper = "StickyHeader-module--wrapper--Zbf9O";
export var visible = "StickyHeader-module--visible--V9qLh";
export var absolute = "StickyHeader-module--absolute--0BlM8";
export var relative = "StickyHeader-module--relative--pMFrp";
export var whiteBg = "StickyHeader-module--whiteBg--DmW2m";